// language check depending on url
import { useLocation } from '@reach/router'

export type Language = 'en' | 'de' | 'fr'

export type Translations = { en: string; fr?: string; de?: string }

export const useLanguage = (): Language => {
  const location = useLocation()
  if (location.pathname.startsWith('/fr/')) {
    return 'fr'
  }
  if (location.pathname.startsWith('/de/')) {
    return 'de'
  }
  return 'en'
}

export const useNavigatorLanguage = (): string => {
  const language: string = navigator.language
  switch (language) {
    case 'es':
    case 'es-ES':
    case 'fr':
    case 'fr-FR':
    case 'fr-LU':
    case 'nl':
    case 'nl-BE':
    case 'nl-NL':
    case 'pt':
    case 'pt-PT':
      return 'Amsterdam'
    case 'de':
    case 'de-AT':
    case 'de-CH':
    case 'de-DE':
    case 'en-GB':
    case 'pl':
    case 'pl-PL':
      return 'Hamburg'
    case 'en':
    case 'en-US':
      return 'Salt Lake City'
    case 'en-AU':
      return 'Melbourne'
    default:
      return 'All'
  }
}
